import React from 'react'
import styles from './label.styles'
import injectSheet from 'react-jss'

const Label = ({ classes, children, htmlFor }) => (
  <label className={classes.label} htmlFor={htmlFor}>
    {children}
  </label>
)

export default injectSheet(styles)(Label)
